import { render, staticRenderFns } from "./jobApproval.vue?vue&type=template&id=4dda5c2e&scoped=true&"
import script from "./jobApproval.vue?vue&type=script&lang=js&"
export * from "./jobApproval.vue?vue&type=script&lang=js&"
import style0 from "./jobApproval.vue?vue&type=style&index=0&id=4dda5c2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dda5c2e",
  null
  
)

export default component.exports